import React from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  deploymentSizingApiEnabledSelector,
  oneDeploymentResourceSelector,
  currentServiceSelector
} from "Reducers/environment/deployment";
import ServiceInfo from "src/organization/common/components/ServiceInfos";
import Layout from "src/organization/pages/project/environment/services/components/Layout";
import Row from "src/organization/pages/project/environment/services/components/Row";
import { useGetResourceType } from "src/organization/pages/project/environment/services/overview/components/hooks/useGetResourceType";
import RelationshipsServices from "src/organization/pages/project/environment/services/overview/components/RelationshipsServices";
import ServiceMetrics from "src/organization/pages/project/environment/services/overview/components/ServiceMetrics";
import { useAppSelector } from "Store/hooks";

const ServiceOverviewDetails = () => {
  const { organizationId, projectId, environmentId, appName } =
    useDecodedParams<{
      organizationId: string;
      projectId: string;
      environmentId: string;
      appName: string;
    }>();
  const currentService = useSelectorWithUrlParams(currentServiceSelector, {
    key: "services"
  });
  const isSizingApiEnabled = useSelectorWithUrlParams(
    deploymentSizingApiEnabledSelector
  );
  const resourceType = useGetResourceType();

  const currentResource = useAppSelector(state =>
    oneDeploymentResourceSelector(state, {
      organizationId,
      projectId,
      environmentId,
      resourceType,
      appName
    })
  );

  return (
    <>
      <Layout>
        <Row>
          {currentService?.metadata && (
            <ServiceInfo
              metadata={currentService.metadata}
              isServicesTab={true}
              isSizingApiEnabled={isSizingApiEnabled}
              profileLabel={currentResource?.profileLabel}
            />
          )}
        </Row>
      </Layout>
      <ServiceMetrics serviceName={appName} />
      <RelationshipsServices />
    </>
  );
};

export default ServiceOverviewDetails;
